<template>
  <div class="container text-center pb-5 mt-5">
    <h1 class="text-uppercase mt-5 mb-3 d-none">{{$t('Upload.UplaodTitle')}}</h1>
    <p class="d-none">{{$t('Upload.UplaodDesc')}}</p>
    <div class="mb-5">
      <section class="wrapper">
        <component :is="WidgetComponent"  :campaign-id="$t('CampaignID')"></component>
      </section>
    </div>
    
  </div>
</template>

<script>
import CampaignWidgets from '../Home/Homepagecomponents/CampaignWidgets.vue';

export default {
  components: { CampaignWidgets },
  props: {

  },
  data() {
    return {
      showComponent: false,
      WidgetComponent: CampaignWidgets,
    };
  },
};
</script>
